"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processApiKeysLoading = exports.processApiKeys = void 0;
var _api = require("../../../api");
var _slice = require("./slice");
const processApiKeysLoading = () => async dispatch => {
  dispatch(_slice.apiKeysSlice.actions.processApiKeysLoading());
};
exports.processApiKeysLoading = processApiKeysLoading;
const processApiKeys = _ref => {
  let {
    user,
    popupSeen,
    accessToken,
    refreshToken,
    stripeConfig
  } = _ref;
  return async dispatch => {
    dispatch(_slice.apiKeysSlice.actions.setUser(user));
    if (accessToken && refreshToken) {
      (0, _api.setAuthorizationHeader)(accessToken);
      dispatch(_slice.apiKeysSlice.actions.processApiKeysReceived({
        popupSeen,
        accessToken,
        refreshToken,
        stripeConfig
      }));
    } else {
      dispatch(_slice.apiKeysSlice.actions.processApiKeysError());
    }
  };
};
exports.processApiKeys = processApiKeys;